import React, { useCallback, useMemo } from "react";
import classnames from "classnames";
import { Icon, Table } from "@shared/components";
import { AlertNotification, PatientSettings } from "@shared/models";
import { getAlertNotificationsListTableProperties } from "@containers/Alert/constants";
import { HospitalCardEmptyState } from "@containers/Dashboard/components/DashboardHospitalContainer/HospitalCardEmptyState";

import "./index.scss";

interface AlertNotificationsListProps {
  title: string;
  className?: string;
  alertNotifications: AlertNotification[];
  emptyState?: string;
  patientSettings?: PatientSettings;
  onClose: () => void;
  onRowClick?: (item: AlertNotification) => void;
  loadNextPage: () => void;
  onClickMarkAsRead?: (item: AlertNotification) => void;
}

const AlertNotificationsCard = (props: AlertNotificationsListProps) => {
  const {
    title,
    className,
    onClose,
    alertNotifications,
    loadNextPage,
    emptyState,
    patientSettings,
    onClickMarkAsRead,
    onRowClick,
  } = props;

  const isEmpty = useMemo(() => !alertNotifications.length, [alertNotifications]);

  const alertNotificationsListTableProperties = useMemo(() => {
    return getAlertNotificationsListTableProperties(onClickMarkAsRead, patientSettings);
  }, [patientSettings, onClickMarkAsRead]);

  const handleRowClick = useCallback(
    (item: AlertNotification) => {
      onRowClick?.(item);
      onRowClick && onClose();
    },
    [onRowClick, onClose],
  );

  return (
    <div className={classnames("alert-notifications-list", className)}>
      <div className={classnames("alert-notifications-list-title", { "alert-notifications-list-empty": isEmpty })}>
        <div className="alert-notifications-list-title-content">{title}</div>
        <div onClick={onClose} className="alert-notifications-list-title-action">
          <Icon type="clear" />
        </div>
      </div>
      <div className={classnames("alert-notifications-list-content", { empty: isEmpty })}>
        {!isEmpty ? (
          <Table<AlertNotification>
            items={alertNotifications}
            properties={alertNotificationsListTableProperties}
            onFinishScroll={loadNextPage}
            onRowClick={handleRowClick}
            isDisabledHoverRow={true}
          />
        ) : (
          <HospitalCardEmptyState title={emptyState} />
        )}
      </div>
    </div>
  );
};

export default AlertNotificationsCard;
